import { join } from 'node:path';
import { getExtensionDir } from './definitions.js';

export function getBackendEventExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'backend', 'events');
}

export function getBackendEventExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getBackendEventExtensionsDir(projectFolder), extensionPath);
}

export function getBackendPluginExtensionsDir(projectFolder: string) {
  return join(getExtensionDir(projectFolder), 'backend', 'service-plugins');
}

export function getBackendPluginExtensionPath(
  projectFolder: string,
  extensionPath: string
) {
  return join(getBackendPluginExtensionsDir(projectFolder), extensionPath);
}
